import { render, staticRenderFns } from "./MySignature.vue?vue&type=template&id=22420aae&scoped=true&"
import script from "./MySignature.vue?vue&type=script&lang=js&"
export * from "./MySignature.vue?vue&type=script&lang=js&"
import style0 from "./MySignature.vue?vue&type=style&index=0&id=22420aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22420aae",
  null
  
)

export default component.exports